import { ShopperAddressResponse, ShopperPaymentMethodResponse, ShopperResponse } from './shopper.response';
import { ShopperAddressState, ShopperPaymentMethodState, ShopperState } from './shopper.state';

/** Pure wire → state mappers for the shopper endpoints (no date fields). */

export function mapShopperAddressResponse(response: ShopperAddressResponse): ShopperAddressState {
  return { ...response };
}

export function mapShopperPaymentMethodResponse(response: ShopperPaymentMethodResponse): ShopperPaymentMethodState {
  return { ...response };
}

export function mapShopperResponse(response: ShopperResponse): ShopperState {
  return {
    ...response,
    defaultLocation: { ...response.defaultLocation },
    addresses: response.addresses.map(mapShopperAddressResponse),
    notificationTopics: [...response.notificationTopics],
    paymentMethods: response.paymentMethods.map(mapShopperPaymentMethodResponse)
  };
}
